import Image from "next/image";
const Logo = () => (
    <Image height={62} width={100} src="/spectacle.png" alt={"Spectacle Logo"} />
);

export default Logo;
